import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import Header from 'components/Header/header'
import Footer from 'components/Footer/footer'
import { mediaQueries } from 'devices'
import ReactGA from 'react-ga'
import { useLocation } from 'react-router'

const MainPanel = ({ children }) => {
  const [isMobileNav, setIsMobileNav] = useState(false)
  const location = useLocation()
  useEffect(() => {
    ReactGA.set({ page: location.pathname })
    ReactGA.pageview(location.pathname)
  }, [location])
  return (
    <>
      <Header isMobileNav={isMobileNav} setIsMobileNav={setIsMobileNav} />
      <Container isMobileNav={isMobileNav}>
        <Body>{children}</Body>
        <Footer />
      </Container>
    </>
  )
}

export default MainPanel

const Container = styled.div`
  ${mediaQueries.tabport} {
    overflow-y: ${({ isMobileNav }) => (isMobileNav ? 'hidden' : 'auto')};
    height: ${({ isMobileNav }) => (isMobileNav ? `calc(100vh - 200rem)` : '')};
  }
`
const Body = styled.div`
  min-height: calc(100vh - 420px);
  position: relative;
`
